(function() {
  try {
    const currentPath = window.location.pathname;

    // Explicit redirects map for consolidated Low-Pro pages
    const redirectMap = [
      {
        target: '/products/low-pro-iwb-holster',
        patterns: [
          /^\/products\/low-pro-iwb-holster-for-.+$/i,
          /^\/products\/low-pro-iwb-for-.+$/i,
          /^\/products\/low-pro-iwb-holster-.+$/i,
          /^\/products\/low-pro-iwb-.+$/i
        ]
      },
      {
        target: '/products/low-pro-owb-holster',
        patterns: [
          /^\/products\/low-pro-owb-holster-for-.+$/i,
          /^\/products\/low-pro-owb-for-.+$/i,
          /^\/products\/low-pro-owb-holster-.+$/i,
          /^\/products\/low-pro-owb-.+$/i
        ]
      },
      {
        target: '/products/low-pro-belly-band-holster',
        patterns: [
          /^\/products\/low-pro-belly-band-holster-for-.+$/i,
          /^\/products\/low-pro-belly-band-for-.+$/i,
          /^\/products\/low-pro-belly-band-holster-.+$/i,
          /^\/products\/low-pro-belly-band-.+$/i,
          /^\/products\/low-pro-belly-holster-for-.+$/i,
          /^\/products\/low-pro-belly-for-.+$/i,
          /^\/products\/low-pro-belly-holster-.+$/i,
          /^\/products\/low-pro-belly-.+$/i
        ]
      }
    ];

    // Find the first matching redirect rule
    for (const rule of redirectMap) {
      if (currentPath === rule.target) continue; // Already at the target URL

      const matches = rule.patterns.some(pattern => pattern.test(currentPath));
      if (matches) {
        window.location.replace(rule.target);
        break; // Stop evaluating rules once redirected
      }
    }
  } catch (e) {
    console.error('Low-Pro redirects error:', e);
  }
})();
